import { render, staticRenderFns } from "./ppdb.vue?vue&type=template&id=13bb93e2&scoped=true"
import script from "./ppdb.vue?vue&type=script&lang=js"
export * from "./ppdb.vue?vue&type=script&lang=js"
import style0 from "./ppdb.vue?vue&type=style&index=0&id=13bb93e2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13bb93e2",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {CoreView: require('/app/components/core/View.vue').default,CoreFooter: require('/app/components/core/Footer.vue').default})
